import { render, staticRenderFns } from "./NlQueryStatusChip.vue?vue&type=template&id=5772aa6a"
import script from "./NlQueryStatusChip.vue?vue&type=script&lang=js"
export * from "./NlQueryStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports